import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9eebaa4c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9eebaa4c')) {
      api.createRecord('9eebaa4c', component.options)
    } else {
      api.reload('9eebaa4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9eebaa4c&", function () {
      api.rerender('9eebaa4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/index.vue"
export default component.exports